/**
 * Created by Ning Jiang on 2021-06-09.
 */
import {WinPresentationController} from "../WinPresentationController";
import {TombstoneRip} from "../../TombstoneRip";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {gsap, TimelineLite} from "gsap";
import {TombstoneRipSound} from "../../sound/TombstoneRipSound";

export class ReelSplitController extends WinPresentationController {

    private _animations:TimelineLite[] = [];
    private _pauseTl:TimelineLite | null;
    private _skipped:boolean;

    constructor() {
        super("ReelSplitController", true);
    }

    protected hasWin():boolean {
        return TombstoneRip.model.parsedGameData.reelSplit.some(v => v);
    }

    protected async createWinAnimation():Promise<void> {
        TombstoneRip.playFSWin = true;
        this._skipped = false;
        const promises:Promise<any>[] = [];
        const splitReels:number[] = [];
        const noWin:boolean = TombstoneRip.model.parsedGameData.singleWin === 0;
        let symbolDelay:number = 100;
        TombstoneRip.model.parsedGameData.reelSplit.forEach((split, reelId) => {
            if(split) {
                splitReels.push(reelId);
                const tl = new TimelineLite();
                for(let i = 0; i < 3; i++) {
                    const symbol = TombstoneRip.reels[reelId].getSymbol(i);
                    tl.add(symbol.split(0, noWin), noWin ? 0 : (symbol.symbolName === "WRS" ? 0 : symbol.splitSymbolDelay));
                    if(symbol.symbolName != "WRS") {
                        symbolDelay = Math.min(symbolDelay, symbol.splitSymbolDelay);
                    }
                }
                tl.add(() => TombstoneRip.ways.reelSplit(reelId));
                tl.add(() => ArrayHelper.removeFirstMatchElement(this._animations, tl));
                this._animations.push(tl);
                promises.push(Promise.resolve(tl))
            }
        });

        this.playSplitSound(splitReels);
        if(!noWin) {
            const soundTl = new TimelineLite();
            soundTl.add(() => {TombstoneRipSound.soundPlayer.playTrack({name : TombstoneRipSound.WRS_SPLIT_REEL})}, symbolDelay);
            this._animations.push(soundTl);
            promises.push(Promise.resolve(soundTl));
        }

        await Promise.all(promises);

        if(!this._skipped) {
            this._pauseTl = new TimelineLite();
            this._pauseTl.add(gsap.to(this, {duration : 0.8}));
            this._pauseTl.add(() => this._pauseTl = null);
            await Promise.resolve(this._pauseTl);
        }
    }

    public skip():void {
        this._skipped = true;
        this._animations.forEach(animation => {
            animation.timeScale(2);
        });
        if(this._pauseTl && this._pauseTl.isActive()) {
            this._pauseTl.progress(1);
        }
    }

    private playSplitSound(reels:number[]):void {
        TombstoneRipSound.soundPlayer.playTrack({name : TombstoneRipSound.WRS_SPLIT});
    }
}